/**
 * Large animated ring on the Result screen.
 * Animates stroke-dashoffset on mount via double-rAF (mirrors mockup).
 */
import { useEffect, useRef, useState } from 'react'

interface Props {
  fraction: number
  top?: boolean  // 100% → green
}

const R = 64
const STROKE = 11
const C = 2 * Math.PI * R

export function BigRing({ fraction, top = false }: Props) {
  const fillRef = useRef<SVGCircleElement>(null)
  const [val, setVal] = useState('0%')

  useEffect(() => {
    const el = fillRef.current
    if (!el) return
    el.setAttribute('stroke-dasharray', String(C))
    el.setAttribute('stroke-dashoffset', String(C))
    // double rAF so the transition picks up the new value (mockup pattern)
    const id1 = requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        el.setAttribute('stroke-dashoffset', String(C * (1 - fraction)))
      })
    })
    const t = setTimeout(() => setVal(`${Math.round(fraction * 100)}%`), 100)
    return () => {
      cancelAnimationFrame(id1)
      clearTimeout(t)
    }
  }, [fraction])

  return (
    <div className={`big-ring${top ? ' top' : ''}`}>
      <svg viewBox="0 0 150 150">
        <circle
          className="track"
          cx={75}
          cy={75}
          r={R}
          fill="none"
          strokeWidth={STROKE}
        />
        <circle
          ref={fillRef}
          className="fill"
          cx={75}
          cy={75}
          r={R}
          fill="none"
          strokeWidth={STROKE}
          strokeLinecap="round"
        />
      </svg>
      <div className="val">{val}</div>
    </div>
  )
}
